<template>
  <div id="loyout">
    <el-container>
      <layoutAside></layoutAside>
      <div class="main-container">
        <layoutHeader></layoutHeader>
        <section class="section-main">
          <transition name="main" mode="out-in">
            <keep-alive  :include="include">
              <router-view :key="key"></router-view>
            </keep-alive>
          </transition>
        </section>
      </div>
    </el-container>
  </div>
</template>

<script>
import layoutAside from "./aside/aside";
import layoutHeader from "./header/header";
import langSelect from "../../components/lang/langSelect";

export default {
  name: "dc-home",
  components: {
    layoutHeader,
    langSelect,
    layoutAside,
  },
  
  data() {
    return {};
  },
  computed:{
    include(){
      return this.$store.state.layout.tabnavBox.map(i=>i.title).join(',')
    },
    key(){
      return this.$route.path
    }
  },
  created() {
    this.$router.push("/index"); //路由刷新时回到首页
  },
  // beforeUpdate() {
  //   this.include = this.$store.state.layout.tabnavBox
  //     .map((i) => i.title)
  //     .join(",");
  // },
};
</script>

<style>
.main-enter,
.main-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.main-enter-active {
  transition: all 0.2s;
}

.main-leave-active {
  position: absolute;
  transition: all 0.3s;
}
</style>
<style lang="scss">
* {
  margin: 0px;
  padding: 0px;
}

body {
  background-color: #f2f2f2;
  font-size: 14px;
  color: #333333;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}

$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: ($left, $right);

%w100 {
  width: 100%;
}

%h100 {
  height: 100%;
}

%cursor {
  cursor: pointer;
}

.section-main {
  flex: 1 1 auto;
  // overflow: hidden;
  overflow-y: auto;
}

html,
body,
#loyout,
.el-container,
#asideNav,
ul.el-menu {
  @extend %h100;
}
@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}
.main-container {
  background-color: #fff;
  // position: relative;
  flex-direction: column;
  display: flex;
  flex: 1 1 auto;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue